export default "__VITE_ASSET__v0Fsxtr8__"